import WarningAmber from '@mui/icons-material/WarningAmber';
import { ClosableBanner } from '@src/common/components/ClosableBanner';
import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import { theme } from '@src/common/styles/Theme';
import { useTranslation } from 'react-i18next';

export const QuickbookIdBanner = () => {
  const { t } = useTranslation();

  return (
    <ClosableBanner severity="warning" style={bannerStyle}>
      <Stack direction="row" spacing={theme.spacing[2]}>
        <WarningAmber />
        <Stack
          direction="column"
          spacing={theme.spacing[2]}
          alignItems="flex-start"
          sx={{ width: '100%' }}
        >
          <Typography variant="subtitle2">
            {t('reviewPermit.quickbooksWarningTitle')}
          </Typography>
          <Typography variant="body2">
            {t('reviewPermit.quickbooksWarningMessage')}
          </Typography>
        </Stack>
      </Stack>
    </ClosableBanner>
  );
};

const bannerStyle = {
  position: 'absolute',
  top: theme.spacing[8],
  maxWidth: 520,
  border: 'none',
  alignSelf: 'flex-end',
};
